import * as React from 'react';
import {Route, RouteComponentProps, Switch, withRouter} from 'react-router';
import {GUARD_LOGGEDIN} from '../../routes';
import DailyOfferByVstGrp from './DailyOfferByVstGrp';
import DailyOfferByVstGrpGuests from './DailyOfferByVstGrpGuests';
import DailyOfferDetail from './DailyOfferDetail';

interface PageProps extends RouteComponentProps<{}> {
}

class RoutesPage extends React.Component<PageProps, {}> {

  public render() {
    const match = this.props.match;
    return (
        <Switch>
          <Route path={`${match.path}/:vstGrp/:type/:ccBiggerZero`} component={DailyOfferDetail}/>
          {!GUARD_LOGGEDIN() && <Route path={`${match.path}`} component={DailyOfferByVstGrpGuests} />}
          {GUARD_LOGGEDIN() && <Route path={`${match.path}`} component={DailyOfferByVstGrp} />}
        </Switch>
    );
  }
}

export default withRouter(RoutesPage);